export default {
	form: {
		required_error: 'Dieses Feld ist erforderlich',
		max_length_exceeded_error:
			'Dieses Feld ist zu lang (maximal {{length}} Zeichen)'
	},
	legal: {
		copyright: 'Gerositus Sàrl - Alle Rechte vorbehalten',
		i_consent: 'Ich stimme zu',
		agreement_title: 'Vereinbarung',
		agreement_content:
			'Durch die Nutzung von Gerositus stimmen Sie unseren <1>Nutzungsbedingungen</1> und <2>Datenschutzrichtlinie</2> zu.',
		agreement_terms_conditions: 'Nutzungsbedingungen',
		agreement_privacy_policy: 'Datenschutzrichtlinie',
	},
	navigation: {
		home: 'Home'
	},
	yes: 'Ja',
	no: 'Nein',
	not_defined: 'Nicht definiert',
	please_wait: 'Bitte warten',
	search: 'Suchen',
	upgrade_required: 'Upgrade required',
	create_project_title: 'What would you like to achieve?',
	click_to_change: 'Click to change',
	click_to_create_one: 'Click <button>to create one</button>',
	no_goal: 'No goal',

	auth: {
		token_expiring_soon: 'Ihre Sitzung läuft in {{minutes}} Minuten ab',
		token_expired:
			'Ihre Sitzung ist abgelaufen. Sie werden zur Anmeldeseite weitergeleitet.',
		token_check_error: 'Fehler beim Überprüfen des Tokens',
		session_expiring:
			'Ihre Sitzung läuft bald ab. Bitte verbinden Sie sich neu. Verbleibende Zeit: {{time}}'
	},
	bot: {
		placeholder: 'Geben Sie hier Ihre Frage ein',
		security_notice: 'Private, isolierte KI. Ihre Gespräche bleiben vertraulich.'
	},
	tutorial: {
		button: 'Tutorial',
		exit_title: 'Exit tutorial',
		exit_confirm: 'Are you sure you want to exit the tutorial?'
	},
	subscription: {
		billing_monthly: 'Monthly',
		billing_yearly: 'Yearly',
		billing_yearly_save: '(save 20%)',
		choose_now: 'Choose now'
	},
	icons: {
		used: 'Used',
		unused: 'Unused'
	},
	theme: {
		selector: 'Theme-Auswahl',
		current_theme: 'Aktuelles Theme',
		change_theme: 'Theme ändern'
	},
	no_description: 'Keine Beschreibung',
	situation_analysis: {
		title: 'Situationsanalyse',
		description: 'Eine Organisation, ein Unternehmen oder eine Situation automatisch analysieren',
		organization_label: 'Organisation / Unternehmen',
		organization_placeholder: 'Name der zu analysierenden Organisation',
		subject_label: 'Thema',
		subject_placeholder: 'Zu analysierendes Thema (mit dem Projektnamen vorausgefüllt)',
		launch_analysis: 'Analyse starten',
		analysis_in_progress: 'Analyse läuft...',
		complete_analysis: 'Analyse abschließen',
		waiting_analysis: 'Warte auf Analyse...',
		waiting_summary: 'Warte auf Zusammenfassung...',
		waiting_stakes: 'Warte auf Schlüsselthemen...',
		waiting_risks: 'Warte auf Risiken...',
		waiting_openings: 'Warte auf Chancen...',
		waiting_stakeholders: 'Warte auf Stakeholder...',
		context_title: 'Allgemeiner Kontext',
		summary_title: 'Zusammenfassung',
		stakes_title: 'Schlüsselthemen',
		risks_title: 'Risiken',
		openings_title: 'Chancen',
		stakeholders_title: 'Stakeholder',
		status: 'Status',
		likelihood: 'Wahrscheinlichkeit',
		impact: 'Auswirkung',
		stakeholder: {
			importance_label: 'Relative Bedeutung',
			propensity_label: 'Tendenz',
			engagement_label: 'Engagement',
			importance_values: {
				low: 'Niedrig',
				medium: 'Mittel',
				high: 'Hoch'
			},
			propensity_values: {
				green: 'Unterstützend',
				neutral: 'Neutral',
				orange: 'Angespannt',
				red: 'Ablehnend'
			},
			engagement_values: {
				inactive: 'Inaktiv',
				neutral: 'Neutral',
				low: 'Niedrig',
				medium: 'Mittel',
				high: 'Stark'
			},
			polarity_values: {
				positive: 'Unterstützung',
				negative: 'Widerstand'
			}
		},
		risk_category_values: {
			operational: 'Operativ',
			strategic: 'Strategisch',
			existential: 'Existenziell'
		}
	},
	ai_project_generation: {
		checkbox_label: 'Inhalt mit KI generieren',
		checkbox_tooltip: "Verwendet Titel, Mission, Beschreibung und die unten aufgeführten Szenarien. Die öffentliche KI-Suche startet erst nach Ihrer Bestätigung („Projekt erstellen“).",
		title: 'KI-gestützte Projekterstellung',
		go_to_project: 'Zum Projekt',
		create_project: 'Projekt erstellen',
		include_in_project_aria: 'Dieses Element ins Projekt aufnehmen',
		creation_modal_title: 'Elemente werden erstellt',
		creation_progress_text: '{{current}} / {{total}} Elemente erstellt',
		error_title: 'Fehler bei der Generierung',
		complete_title: 'Generierung abgeschlossen',
		complete_description: 'Ihr Projekt wurde erfolgreich angereichert. Die KI hat zentrale Stakeholder, Schlüsselthemen, Risiken und Chancen identifiziert.',
		summary_title: 'Analyse-Zusammenfassung',
		initializing_text: 'Tiefenanalyse wird vorbereitet… Dies kann 6 bis 10 Minuten dauern.',
		include_in_project_tooltip: 'Wenn aktiviert, wird dieses Element bei „Projekt erstellen" angelegt.',
		language_code: 'de',
		patience_with_scenarios:
			'Die Szenariogenerierung ist komplex und kann einige Minuten dauern. Vielen Dank für Ihre Geduld.',
		patience_no_scenarios:
			'Die ausführliche Analyse kann einige Minuten dauern. Vielen Dank für Ihre Geduld.',
		phases: {
			initializing: 'Start',
			deep_research: 'Recherche',
			analyzing: 'KI-Analyse',
			stakeholders: 'Stakeholder',
			stakes: 'Schlüsselthemen',
			risks: 'Risiken',
			openings: 'Chancen',
			summary: 'Zusammenfassung',
			fishbone: 'Aktionsplan',
			entities: 'Entitäten',
			scenarios: 'Szenarien',
			completed: 'Abgeschlossen',
			error: 'Fehler'
			},
		section_title: "Details der KI-Generierung",
		disclosure_public_title: "An öffentliche KI",
		disclosure_public_sub: "Web-Recherche. Erhält nur die neutrale Vorschau unten — ohne Absicht, ohne Ziele.",
		disclosure_private_title: "Private, isolierte KI",
		disclosure_private_sub: "Läuft in einer isolierten Umgebung. Kein Retraining, keine Datenübertragung nach außen. Verarbeitet Titel, Mission, Beschreibung und Szenarien.",
		zone_public: "An öffentliche KI gesendet",
		zone_private: "Privat — nicht an öffentliche KI gesendet",
		field_private_chip: "Privat & sicher",
		field_private_tooltip: "Wird von einer privaten KI in einer isolierten Umgebung verarbeitet. Kein Retraining, keine Datenübertragung nach außen.",
		preview_title: "Such-Vorschau",
		preview_refresh: "Vorschau neu generieren",
		preview_hint: "Neutrale Umformulierung Ihres Themas — ohne Spur von Absicht. Genau das wird an die öffentliche Suche gesendet — erst nach Ihrer Bestätigung.",
		preview_placeholder: "Geben Sie mindestens den Projekttitel ein, um die Vorschau zu erzeugen.",
		launch_generation: "Generierung starten",
		fishbone_source: 'Quelltext',
		scenario_n: 'Szenario {{n}}',
		scenario_optimistic: 'Günstig',
		scenario_baseline: 'Wahrscheinlich',
		scenario_pessimistic: 'Ungünstig',
		scenario_pending: 'Ausstehend',
		scenario_triggers: 'Auslösende Ereignisse',
		scenario_action_window: 'Handlungsfenster',
		scenario_detail: 'Detailanalyse',
		dismiss: 'KI-Vorschläge verwerfen und Projekt erstellen',
		save_pdf: 'Als PDF speichern',
		save_hint: 'Sie können diese Analyse vor dem Eintreten ins Projekt speichern.',
		scenario_impacts: 'Auswirkungen pro Entität',
		data: {
			scenarios: 'Prospektive Szenarien',
			fishbone: 'Strategischer Aktionsplan'
		}
	},
	scenario_elaboration: {
		title: 'KI-Szenarienelaboration',
		hypothesis: 'Hypothese',
		initializing: 'Analyse wird initialisiert...',
		error_title: 'Fehler bei der Elaboration',
		complete_title: 'Elaboration abgeschlossen',
		complete_description: 'Das Szenario wurde erfolgreich elaboriert. Die Änderungen wurden übernommen.',
		analysis_preview: 'Vorläufige Analyse',
		applied_changes: 'Übernommene Änderungen',
		stakeholders_modified: 'Stakeholder geändert',
		stakes_modified: 'Schlüsselthemen geändert',
		risks_modified: 'Risiken/Chancen geändert',
		indicators_modified: 'Indikatoren geändert',
		new_elements: 'neue',
		steps: {
			started: 'Start',
			started_desc: 'Analyse wird initialisiert...',
			fetching_project: 'Projekt wird geladen',
			fetching_project_desc: 'Projektdaten werden geladen...',
			deep_research: 'Erstanalyse',
			deep_research_desc: 'Tiefgehende Situationsanalyse...',
			ai_analysis: 'KI-Analyse',
			ai_analysis_desc: 'Die KI analysiert die Auswirkungen der Hypothese...',
			reformatting: 'Formatierung',
			reformatting_desc: 'Ergebnisse werden strukturiert...',
			processing_stakeholders: 'Stakeholder',
			processing_stakeholders_desc: 'Stakeholder-Auswirkungen werden berechnet...',
			processing_stakes: 'Schlüsselthemen',
			processing_stakes_desc: 'Auswirkungen auf Schlüsselthemen werden berechnet...',
			processing_risks: 'Risiken',
			processing_risks_desc: 'Risiko-Auswirkungen werden berechnet...',
			processing_indicators: 'Indikatoren',
			processing_indicators_desc: 'Indikator-Auswirkungen werden berechnet...',
			completed: 'Abgeschlossen',
			completed_desc: 'Analyse erfolgreich abgeschlossen',
			error: 'Fehler',
			error_desc: 'Ein Fehler ist aufgetreten'
		}
	}
};
